/**
 * @typedef {Object} MultiSelectionPluginOptions
 * @property {Function} [onChanged]
 * @property {String} [showCheckBoxesMode]
 * @property {String} [selectAllMode]
 */

/**
 * @param {MultiSelectionPluginOptions} [options = {}]
 * @param {String} [options.showCheckBoxesMode] - DevExtreme showCheckBoxesMode (default "always",
 *   where a row click selects nothing; pass "onClick" to select on row click)
 * @param {String} [options.selectAllMode] - DevExtreme selectAllMode (default "allPages"; pass "page"
 *   so the "select all" checkbox only selects the rows that are loaded)
 *
 * @returns {import("../datagrid").Plugin}
 */
export function multiSelectionPlugin(options = {}) {
  return {
    id: "multiSelection",
    onSelectionChanged: options.onChanged,
    options: {
      selection: {
        mode: "multiple",
        showCheckBoxesMode: options.showCheckBoxesMode ?? "always",
        selectAllMode: options.selectAllMode ?? "allPages",
      },
    },
  };
}
